<template>
	<div class="row">
		<div
			class="col"
			:class="[columnClasses]"
			v-for="c in Math.min(cols * 1, items.length)"
		>
			<template v-for="item in perColumn(items, cols, c - 1)">
				<slot name="item" v-bind="item"> </slot>
			</template>
		</div>
	</div>
</template>

<script setup lang="ts">
const {
	cols = 1,
	items = ["test"],
	columnClasses = "",
} = defineProps<{
	cols: number;
	items: Array<Object>;
	columnClasses: string;
}>();

console.log(items);
function perColumn(full_list: Array<Object>, columns: number, column: number) {
	console.log(column);
	return full_list.filter((e, i) => {
		return i % columns == column;
	});
}
</script>
